<template>
    <div>
        <div class="top" @click="backClick">
            <img src="https://imagessl.edujia.com/A-1ed71af7_20230804162525.png" crossorigin="Anonymous"/>
            <div>返回</div>
        </div>
        <div class="list">
            <!-- <div class="fileItem" @click="fileClick">测试文件</div> -->
            <!-- <div class="fileItem" @click="videoClick">测试视频</div> -->

            <!-- <img v-for="(item,idx) in list" class="imgItem" :src="item.val" crossorigin="Anonymous" @click="imgClick(idx)"/> -->
            <div v-for="(item,idx) in list" :key="'show'+item.val">
                <!-- 展示用缩略图（服务端裁剪），加载完成前显示占位，加载完成后覆盖；点击发送时再按原图地址加载完整图片 -->
                <div v-if="item.type=='img'" class="imgBox">
                    <img class="imgBoxImg" :class="{'imgBoxImgHide':!item.loaded}" :data-idx="idx"
                        :src="getThumbUrl(item.val)" loading="lazy"
                        @load="onThumbLoad(item)" @error="onThumbError($event,item)" @click="imgClick(idx)"/>
                    <div v-if="!item.loaded" class="imgLoading">
                        <div v-if="item.failed" class="imgLoadingFail">加载失败</div>
                        <div v-else class="imgLoadingSpinner"></div>
                    </div>
                </div>
                <video v-else-if="item.type=='video'" class="imgItem" :src="item.val" preload="metadata" controls></video>
                <div v-else-if="item.type=='file'" class="fileItem" @click="fileClick(idx)">
                    <img class="fileItemImg" :src="item.fileIcon" />
                    <div class="fileItemDiv">{{item.title}}</div>
                    <div v-if="miniCodeUrl" class="filePoster" :id="'filePoster'+item.val">
                        <div class="filePosterT">
                            <img :src="item.fileIcon" />
                            <div>{{item.title}}</div>
                        </div>
                        <div class="filePosterB">
                            <img class="filePosterBImg" :src="'data:image/png;base64,'+miniCodeUrl" />
                            <div>扫一扫查看文件</div>
                        </div>
                    </div>
                </div>
                <div v-else-if="item.type=='audio'"  class="fileItem" @click="audioClick(idx)">
                    <img class="fileItemImg" :src="item.fileIcon" />
                    <div class="fileItemDiv">{{item.title}}</div>
                    <div class="filePoster" :id="'audioPoster'+item.id">
                        <div class="filePosterT">
                            <img :src="item.fileIcon" />
                            <div>{{item.title}}</div>
                        </div>
                        <div class="filePosterB">
                            <div class="filePosterBImg" :id="'audioQr'+item.id"></div>
                            <div>扫一扫查看文件</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import html2canvas from  'html2canvas';
    import QRCode from 'qrcodejs2'

    export default {
        props:[],
        data(){
            return {
                pageWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                pageHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
                list:[],
                miniCodeUrl:"",
                loading:null
            }
        },
        components:{
            
        },
        methods:{
            /**
             * 二进制容器
             * @param {String} dataurl
             */
             getUint8Arr(dataurl){
                // 截取base64的数据内容
                let arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    // 获取解码后的二进制数据的长度，用于后面创建二进制数据容器
                    n = bstr.length,
                    // 创建一个Uint8Array类型的数组以存放二进制数据
                    u8arr = new Uint8Array(n)
                // 将二进制数据存入Uint8Array类型的数组中
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return { u8arr, mime }
            },
            /**
             * canvas转dataURL
             * @param {canvas} canvas
             */
             convertCanvasToImage(canvas){
                // let image = new Image()
                // image.src = canvas.toDataURL('image/png')
                return canvas.toDataURL('image/png')
            },
            /**
             * dataURL转Blob对象
             * @param {String} dataurl
             */
            dataURLtoBlob(dataurl){
                let uint8 = this.getUint8Arr(dataurl)
                return new Blob([uint8.u8arr], { type: uint8.mime })
            },
            /**
             * Blob转换为File
             * @param {Blob} theBlob
             * @param {String} fileName
             */
            blobToFile(theBlob, fileName){
                theBlob.lastModifiedDate = new Date()
                theBlob.name = fileName
                return theBlob
            },
            generateFilePoster(domId){
                return new Promise ((resolve,reject)=>{
                    html2canvas(document.getElementById(domId),{
                        useCORS: true,
                    }).then((canvas)=> {
                        // document.body.appendChild(canvas);
                        let dataUrl=this.convertCanvasToImage(canvas);
                        let blob=this.dataURLtoBlob(dataUrl);
                        // let file=this.blobToFile(blob,domId);
                        resolve(blob)
                    });
                })
            },
            backClick(){
                this.$router.back(-1)
            },
            // 图片元素转base64（按原始像素尺寸导出，保证发出去的是原图）
            getBase64Image(img) {
                let width = img.naturalWidth || img.width;
                let height = img.naturalHeight || img.height;
                let canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                let ctx = canvas.getContext('2d');
                ctx?.drawImage(img, 0, 0, width, height);
                let dataURL = canvas.toDataURL('image/png');
                return dataURL;
            },
            // 图片元素转base64
            getBase64(img) {
                let canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx?.drawImage(img, 0, 0, img.width, img.height);
                let dataURL = canvas.toDataURL('image/png');
                return dataURL;
            },
            // base64图片转为blob
            getBlobImage(dataurl) {
                let arr = dataurl.split(',');
                let mime = arr[0].match(/:(.*?);/)[1];
                let bstr = atob(arr[1]);
                let n = bstr.length;
                let u8arr = new Uint8Array(n);
                while (n--) {
                  u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], { type: mime });
            },
            // 复制图片（写入剪贴板）
            copyImage(dom,callback,failCallback) {
                let dataurl = this.getBase64Image(dom);
                let blob = this.getBlobImage(dataurl);
                navigator.clipboard.write([
                  new window.ClipboardItem({
                    [blob.type]: blob
                  })
                ]).then(callback, function(error) {
                  console.log('图片复制失败！', error);
                  if(typeof failCallback=='function'){
                    failCallback();
                  }
                });
            },
            // 列表展示用缩略图：七牛CDN的图片处理接口，由服务端返回小图（格子138px，取2倍图276px，webp更省流量）
            // 不支持的域名会忽略参数或返回失败，由 onThumbError 回退到原图
            getThumbUrl(url){
                if(!url||!/^https?:\/\//i.test(url)){
                    return url;
                }
                return url+(url.indexOf('?')>-1?'&':'?')+'imageView2/1/w/276/h/276/format/webp';
            },
            // 缩略图加载完成，覆盖掉占位
            onThumbLoad(item){
                if(item){
                    item.loaded=true;
                    item.failed=false;
                }
            },
            // 缩略图加载失败时回退到原图；原图也失败则显示"加载失败"，避免占位一直转圈
            onThumbError(e,item){
                let img=e&&e.target;
                if(!img||!item){
                    return;
                }
                if(img.dataset.thumbFallback!='1'){
                    img.dataset.thumbFallback='1';
                    img.src=item.val;
                }else{
                    item.failed=true;
                }
            },
            closeLoading(){
                if(this.loading){
                    this.loading.close();
                    this.loading=null;
                }
            },
            sendTypeImg(){
                if(window.require){
                    const {ipcRenderer} = window.require('electron');
                    ipcRenderer.send('type-img');
                }
            },
            imgClick(idx){
                let item=this.list[idx];
                if(!item||!item.val){
                    return;
                }
                console.log("imgClick...");
                this.loading=this.$loading.service({
                  lock: true,
                  text: '发送中...',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)',
                  fullscreen: true
                });
                //列表里展示的是缩略图，发送时必须按原图地址重新加载完整图片，
                //再按原始像素尺寸绘制导出，保证发送的是原图
                let image=new Image();
                image.crossOrigin="Anonymous";
                image.onload=()=>{
                    this.copyImage(image,()=>{
                        this.closeLoading();
                        this.sendTypeImg();
                    },()=>{
                        this.closeLoading();
                        this.$message({
                            message: '图片复制失败，请重试',
                            type: 'warning'
                        });
                    });
                };
                image.onerror=()=>{
                    this.closeLoading();
                    this.$message({
                        message: '原图加载失败，请重试',
                        type: 'warning'
                    });
                };
                image.src=item.val;
            },
            videoClick(){
                let videoUrl="https://videossl.edujia.com/ime/pptzx2/phrase/1696820115853.mp4"
                axios.post( videoUrl, {}, {
                    responseType: 'blob'
                })
                .then(function(response) {
                // this.url = window.URL.createObjectURL(new Blob([response.data]));
                    console.log("file response:",response);
                    let blob=new Blob([response.data],{ type: response.data.type });
                    navigator.clipboard.write([
                      new window.ClipboardItem({
                        [blob.type]: blob
                      })
                    ]).then(function() {
                      // if (typeof cb === 'function') {
                      //   cb();
                      // }
                    }, function(error) {
                      console.log('视频复制失败！ error:',error);
                    });

                });
            },
            async getMiniCode(url,type){
                return new Promise(async (resolve,reject)=>{
                    let params={
                        url:url,
                        type:type,
                    }
                    let resp = await this.$http.huashuGetMiniCode(params)
                    if(resp.code==200){
                        resolve(resp.data.object.image);
                    }
                })
            },
            async fileClick(idx){
                this.loading=this.$loading.service({
                  lock: true,
                  text: '发送中...',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)',
                  fullscreen: true
                });
                console.log("fileClick...")
                let posterId='filePoster'+this.list[idx].val;
                this.miniCodeUrl=await this.getMiniCode(this.list[idx].val,3);
                setTimeout(async ()=>{
                    let blob=await this.generateFilePoster(posterId);
                    navigator.clipboard.write([
                        new window.ClipboardItem({
                            [blob.type]: blob
                        })
                    ]).then(()=>{
                        this.loading.close();
                        const {ipcRenderer} = window.require('electron');
                        ipcRenderer.send('type-img');
                    });
                    // return;

                    // let image=document.getElementById(posterId);
                    // this.copyImage(image,()=>{
                    //     console.log("imgClick...");
                    //     const {ipcRenderer} = window.require('electron');
                    //     ipcRenderer.send('type-img');
                    // });
                },1)
            },
            audioClick(idx){
                this.loading=this.$loading.service({
                  lock: true,
                  text: '发送中...',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)',
                  fullscreen: true
                });
                let itemData=this.list[idx];
                new QRCode("audioQr"+itemData.id, {
                    text: this.list[idx].val, // 需要转换为二维码的内容
                    width: 160,
                    height: 160,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                })

                setTimeout(async ()=>{
                    let blob=await this.generateFilePoster("audioPoster"+itemData.id);
                    navigator.clipboard.write([
                        new window.ClipboardItem({
                            [blob.type]: blob
                        })
                    ]).then(()=>{
                        this.loading.close();
                        const {ipcRenderer} = window.require('electron');
                        ipcRenderer.send('type-img');
                    });
                },1)
            },
            fileClickBak(){
                let fileUrl="https://video.lingtuo.cn/kiXcx/speech/text/media/3mhyjt/1691389495865_0.pdf"
                axios.post( fileUrl, {}, {
                    responseType: 'blob'
                })
                .then(function(response) {
                // this.url = window.URL.createObjectURL(new Blob([response.data]));
                    console.log("file response:",response);
                    let blob=new Blob([response.data],{ type: response.data.type });
                    navigator.clipboard.write([
                      new window.ClipboardItem({
                        [blob.type]: blob
                      })
                    ]).then(function() {
                      // if (typeof cb === 'function') {
                      //   cb();
                      // }
                    }, function() {
                      console.log('文件复制失败！');
                    });

                });
                // let blob = this.getBlobImage(dataurl);
                // navigator.clipboard.write([
                //   new window.ClipboardItem({
                //     [blob.type]: blob
                //   })
                // ]).then(function() {
                //   // if (typeof cb === 'function') {
                //   //   cb();
                //   // }
                // }, function() {
                //   console.log('图片复制失败！');
                // });
                // const {ipcRenderer} = window.require('electron');
                // if(ipcRenderer){
                //     ipcRenderer.send('type-img');
                // }
            },
            //查询话术可添加的文件类型
            async qryHuashuListTitle(list){
                return new Promise(async (resolve,reject)=>{
                    let params={
                        urlArray:JSON.stringify(list),
                    }
                    let resp = await this.$http.qryHuashuListTitle(params);
                    if(resp.code == 200){
                        resolve(resp.data.array);
                    }else{
                        resolve([]);
                    }
                })
            },
        },
        async mounted(){
            console.log("created...");
            window.addEventListener('resize',()=>{
                this.pageWidth=window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                this.pageHeight=window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            })
            if(localStorage.getItem("huashuData")){
                let huashuData=JSON.parse(localStorage.getItem("huashuData"))||{}
                //只查文件/音频的标题；图片不需要标题
                let urlList=(huashuData.filelist||[]).map((file)=>{
                    return file.val;
                })
                let mapList=[]
                if(urlList.length){
                   mapList=await this.qryHuashuListTitle(urlList);
                   if(!Array.isArray(mapList)){
                       mapList=[];
                   }
                }
                let eleList=Array.isArray(huashuData.eleList)?huashuData.eleList:[];
                this.list=eleList.filter((val)=>{
                    if(!val||!val.val||!val.type){
                        return false;
                    }
                    if(val.type=='img'){
                        //图片占位状态：必须在赋值给 this.list 之前定义好，保证是响应式的（Vue2 不会追踪后加的属性）
                        val.loaded=false;
                        val.failed=false;
                    }
                    val.val=val.val.replace("http://","https://")
                    //文件、音频需要展示标题；视频封面图（xxxvideo.jpg / xxxvideo）同样需要。
                    //注意：接口没返回对应 url 时必须兜底，原来的 mapList.find(...).title 会抛异常，
                    //导致 this.list 赋值被中断，整个图片列表变成空白。
                    if(val.type=='file'||val.type=='audio'||(val.type=='img'&&/video(\.[A-Za-z0-9]+)?$/i.test(val.val))){
                        let info=mapList.find((mapItem)=>{
                            return mapItem&&mapItem.url==val.val;
                        })
                        if(info&&info.title){
                            val.title=info.title;
                        }else{
                            let fileName=val.fileName||"";
                            if(!fileName){
                                fileName=val.val.split('/').pop()||"";
                                try{
                                    fileName=decodeURIComponent(fileName);
                                }catch(e){}
                            }
                            val.title=fileName;
                        }
                    }
                    return val.type=='img'||val.type=='video'||val.type=='file'||val.type=='audio'
                })
                //兜底：命中缓存的图片可能在事件绑定前就已加载完成，这里同步一次占位状态
                this.$nextTick(()=>{
                    let imgs=this.$el?this.$el.querySelectorAll('.imgBoxImg'):[];
                    Array.prototype.forEach.call(imgs,(img)=>{
                        let idx=Number(img.dataset.idx);
                        if(img.complete&&img.naturalWidth>0&&this.list[idx]){
                            this.list[idx].loaded=true;
                        }
                    })
                })
            }
        },
    }
</script>

<style scoped>
.top{
    width: 100%;
    height: 57px;
    color: #4a90e2;
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 25px;
    position: fixed;
    left: 0;
    top: 32px;
    background-color: #fff;
}

.top img{
    width: 20px;
    height: 20px;
    margin-left: 14px;
    margin-right: 4px;
}

.list{
    display: flex;
    padding-left: 14px;
    padding-right: 24px;
    flex-wrap: wrap;
    margin-bottom: 8px;
    padding-top: 89px;
}

.imgItem{
    width: 138px;
    height: 138px;
    margin-left: 8px;
    margin-bottom: 8px;
    object-fit: cover;
}

/* 图片缩略图占位：加载中显示loading占位，加载完成后图片覆盖占位 */
.imgBox{
    position: relative;
    width: 138px;
    height: 138px;
    margin-left: 8px;
    margin-bottom: 8px;
    background-color: #F5F6F6;
    overflow: hidden;
}

.imgBoxImg{
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 1;
    transition: opacity .2s;
    cursor: pointer;
}

.imgBoxImgHide{
    opacity: 0;
}

.imgLoading{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F5F6F6;
}

.imgLoadingSpinner{
    width: 18px;
    height: 18px;
    border: 2px solid #dcdcdc;
    border-top-color: #4A90E2;
    border-radius: 50%;
    animation: imgLoadingSpin .8s linear infinite;
}

.imgLoadingFail{
    font-size: 12px;
    color: #BDBDBD;
}

@keyframes imgLoadingSpin{
    to{
        transform: rotate(360deg);
    }
}

.fileItem{
    width: 138px;
    height: 138px;
    margin-left: 8px;
    margin-bottom: 8px;
    background-color: red;   
    background-color: #F5F6F6;
}

.fileItemImg{
    width: 60px;
    height: 60px;
    margin: auto;
    padding-top: 14px;
    display: block;
}

.fileItemDiv{
    width: 130px;
    height: 32px;
    margin-left: 4px;
    margin-top: 21px;
    overflow: hidden;
    font-size: 11px;
    line-height: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: center;
    word-break: break-all;
}

.filePoster{
    width: 610px;
    height: 750px;
    background-color: #fff;
    position: absolute;
    left: -10000px;
    top: -10000px;
    /* left: 0px;
    top: 500px; */
}

.filePosterT{
    width: 496px;
    height: 496px;
    background-color: #F5F6F6;
    margin: 40px 50px 27px 50px;
    border-radius: 4px;
    text-align: center;
}

.filePosterT img{
    widows: 240px;
    height: 240px;
    margin: 70px 128px 50px 128px;
}

.filePosterT div{
    width:376px;
    font-size: 30px;
    overflow: hidden;
    line-height: 42px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: center;
    word-break: break-all;
    margin-left: 60px;
}

.filePosterB{
    display: flex;
    align-items: center;
}

.filePosterBImg{
    width: 160px;
    height: 160px;
    margin: 0px 20px 0px 67px;
}

.filePosterB div{
    font-size: 36px;
    line-height: 50px;
}

</style>